import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientvoucherApiController from "../../services/clientvoucher.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
import { beginClientHistoryRequest, ownsClientHistoryRequest } from "./clientHistoryOwnership";

export const ClientVoucherListViewApi = createAsyncThunk("clientvoucher/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientvoucherApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  listClientId: null,
  listQueryKey: null,
  listRequestId: null,
  isListView: [],
  isListViewError: "",
  isApiStatus: {
    ClientVoucherListViewApi: "",
  },
};

const clientvoucherSlice = createSlice({
  name: "clientvoucher",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientVoucherListViewApi.pending, (state, action) => {
        beginClientHistoryRequest(state, action);
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherListViewApi: "loading" };
        state.isListViewError = "";
      })
      .addCase(ClientVoucherListViewApi.fulfilled, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        const previous = state.isListView;
        const isNextPage = previous && previous.current_page < action.payload.current_page;
        state.isListView = isNextPage && Array.isArray(previous.data) && Array.isArray(action.payload.data)
          ? { ...action.payload, data: [...previous.data, ...action.payload.data] }
          : action.payload;
        state.isListViewError = "";
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherListViewApi: "succeeded" };
      })
      .addCase(ClientVoucherListViewApi.rejected, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherListViewApi: "failed" };
        state.isListViewError = contentErrorMessage(action, "Unable to load vouchers.");
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, openNoteDrawer, closeNoteDrawer, openAddNoteForm, closeAddNoteForm, openEditNoteForm, closeEditNoteForm } = clientvoucherSlice.actions;
export default clientvoucherSlice.reducer;
